"use_client";

import { Colors } from "@/projectRoot/src/utils/models/globalTypes";
import style from "./button.module.scss";
import React, { ComponentProps } from 'react';
import Loader from "../../general/loader/Loader";

export enum ButtonSize {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
}

export enum ButtonTypes {
  BUTTON = "button",
  SUBMIT = "submit",
  RESET = "reset",
}

export interface ButtonProps extends ComponentProps<"button"> {
  label: string;
  type?: ButtonTypes;
  formId?: string;
  backgroundColor?: Colors;
  outline?: boolean;
  size?: ButtonSize;
  classes?: string[];
  disabled?: boolean;
  children?: React.ReactNode;
  dataTest?: string;
  loading?: boolean;
}

export const Button = ({
  label,
  type = ButtonTypes.BUTTON,
  formId = '',
  backgroundColor = Colors.PRIMARY,
  outline = false,
  size = ButtonSize.MEDIUM,
  classes = [],
  disabled,
  children,
  dataTest,
  loading,
  ...rest
}: ButtonProps) => {

  return (
    <button
      // form={formId}
      type={type}
      className={
        `${style.button} ${style[backgroundColor]} ${outline ? style.outline : ""} ${style[size]} ${classes.join(' ')}`
      }
      disabled={disabled || loading}
      data-test={dataTest}
      aria-label={label}
      {...rest}
    >
      {children ? children : label}
      {loading ? <Loader classes={[style.loader]} /> : <></>}
    </button>
  );
};

export default Button;